window.CJD = (function () {
  function init(opts) {
    var sectionId = opts.sectionId;
    var redirectUrl = opts.redirectUrl || '/checkout';
    var root = document.getElementById('cjd-' + sectionId);
    if (!root) return;

    var form = root.querySelector('.cjd-form');
    if (!form) return;

    function show(el) { if (el) { el.hidden = false; el.style.removeProperty('display'); } }
    function hide(el) { if (el) { el.hidden = true; el.style.display = 'none'; } }

    /* ---- Preview logo upload (Step 1 only) ---- */
    var uploadWrap  = root.querySelector('[data-cjd-preview-panel] [data-cjd-upload]');
    var fileInput   = root.querySelector('[data-cjd-preview-logo-input]');
    var fileNameEl  = root.querySelector('[data-cjd-preview-panel] [data-cjd-filename]');
    var chooseBtn   = root.querySelector('[data-cjd-preview-panel] [data-cjd-choose]');

    var notesEl     = root.querySelector('[data-cjd-notes]');
    var countEl     = root.querySelector('[data-cjd-count]');
    var submitBtn   = root.querySelector('[data-cjd-submit]');
    var submitLabel = root.querySelector('[data-cjd-submit-label]');
    var errorEl     = root.querySelector('[data-cjd-error]');
    var qtyInput    = form.querySelector('input[name="quantity"]');
    var addonInputs = root.querySelectorAll('[data-cjd-addon]');
    var totalEl     = root.querySelector('[data-cjd-total]');

    /* ================= Product search & catalog ================= */
    var catalogEl       = root.querySelector('[data-cjd-catalog-data]');
    var catalog         = [];
    if (catalogEl) {
      try { catalog = JSON.parse(catalogEl.textContent); } catch (e) { catalog = []; }
    }
    var searchInput      = root.querySelector('[data-cjd-search]');
    var resultsBox       = root.querySelector('[data-cjd-search-results]');
    var searchHint       = root.querySelector('[data-cjd-search-hint]');
    var selectedInput    = root.querySelector('[data-cjd-selected-product]');
    var selectedChip     = root.querySelector('[data-cjd-selected-chip]');
    var selectedChipImg  = root.querySelector('[data-cjd-selected-chip-img]');
    var selectedChipTitle= root.querySelector('[data-cjd-selected-chip-title]');
    var changeBtn        = root.querySelector('[data-cjd-change-product]');

    /* ================= Preview stage ================= */
    var previewImg    = root.querySelector('[data-cjd-preview-img]');
    var previewEmpty  = root.querySelector('[data-cjd-preview-empty]');
    var previewName   = root.querySelector('[data-cjd-preview-name]');
    var previewNumber = root.querySelector('[data-cjd-preview-number]');
    var previewLogo   = root.querySelector('[data-cjd-preview-logo]');
    var previewStage  = root.querySelector('[data-cjd-preview]');
    var angleSwitcher = root.querySelector('[data-cjd-angle-switcher]');

    /* ---- FIX: point to preview-only inputs, NOT Step 3 name= fields ---- */
    var pnameInput  = root.querySelector('[data-cjd-preview-name-input]');
    var pnumInput   = root.querySelector('[data-cjd-preview-number-input]');
    var pcolorInput = root.querySelector('[data-cjd-preview-color-input]');

    var ANGLE_LABELS = ['Front', 'Back', 'Left', 'Right'];
    var COLOR_MAP = { Black: '#111111', White: '#ffffff', Red: '#e4032e', Blue: '#1a4fd6', Gold: '#caa73e' };

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    function setPreviewImage(src) {
      if (!previewImg) return;
      if (!src) { hide(previewImg); show(previewEmpty); return; }
      previewImg.src = src;
      show(previewImg);
      hide(previewEmpty);
    }

    function padImages(images) {
      var arr = images || [];
      var firstReal = null;
      for (var j = 0; j < arr.length; j++) { if (arr[j]) { firstReal = arr[j]; break; } }
      if (!firstReal) return [];
      var out = [];
      for (var i = 0; i < 4; i++) { out.push(arr[i] || firstReal); }
      return out;
    }

    function renderAngleSwitcher(images) {
      if (!angleSwitcher) return;
      var padded = padImages(images);
      if (padded.length === 0) { angleSwitcher.innerHTML = ''; hide(angleSwitcher); return; }
      angleSwitcher.innerHTML = padded.map(function (src, i) {
        return '<button type="button" class="cjd-angle-btn' + (i === 0 ? ' is-active' : '') +
          '" data-angle-idx="' + i + '">' + ANGLE_LABELS[i] + '</button>';
      }).join('');
      show(angleSwitcher);
      angleSwitcher.querySelectorAll('.cjd-angle-btn').forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          angleSwitcher.querySelectorAll('.cjd-angle-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          setPreviewImage(padded[i]);
        });
      });
    }

    /* ================= Catalog search ================= */
    function renderResults(query) {
      if (!resultsBox) return;
      var q = query.trim().toLowerCase();
      if (q.length < 2) { hide(resultsBox); resultsBox.innerHTML = ''; return; }
      var matches = catalog.filter(function (p) {
        return p.title.toLowerCase().indexOf(q) !== -1;
      }).slice(0, 8);
      if (matches.length === 0) {
        resultsBox.innerHTML = '<div class="cjd-search-empty">No products found for "' + escapeHtml(query) + '"</div>';
        show(resultsBox);
        return;
      }
      resultsBox.innerHTML = matches.map(function (p, i) {
        var thumb = p.images && p.images[0];
        return '<button type="button" class="cjd-search-result" data-idx="' + i + '">' +
          (thumb ? '<img src="' + thumb + '" alt="" loading="lazy">' : '<span class="cjd-search-noimg"></span>') +
          '<span>' + escapeHtml(p.title) + '</span></button>';
      }).join('');
      show(resultsBox);
      resultsBox.querySelectorAll('.cjd-search-result').forEach(function (btn, i) {
        btn.addEventListener('click', function () { selectProduct(matches[i]); });
      });
    }

    function selectProduct(p) {
      if (selectedInput) selectedInput.value = p.title;
      var searchCol = root.querySelector('.cjd-search-col');
      if (searchCol) searchCol.classList.remove('cjd-invalid');
      var images = p.images || [];
      setPreviewImage(images[0] || '');
      renderAngleSwitcher(images);
      if (selectedChipImg) selectedChipImg.src = images[0] || '';
      if (selectedChipTitle) selectedChipTitle.textContent = p.title;
      show(selectedChip);
      hide(searchHint);
      resultsBox && (resultsBox.innerHTML = '');
      hide(resultsBox);
      if (searchInput) {
        searchInput.value = '';
        var box = searchInput.closest('.cjd-search-box');
        if (box) hide(box);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () { renderResults(searchInput.value); });
    }
    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        hide(selectedChip);
        show(searchHint);
        if (searchInput) {
          var box = searchInput.closest('.cjd-search-box');
          if (box) show(box);
          searchInput.focus();
        }
      });
    }

    /* ================= Live text/color sync (preview-only inputs → canvas) ================= */
    if (pnameInput && previewName) {
      pnameInput.addEventListener('input', function () { previewName.textContent = pnameInput.value; });
    }
    if (pnumInput && previewNumber) {
      pnumInput.addEventListener('input', function () { previewNumber.textContent = pnumInput.value; });
    }
    if (pcolorInput && previewName && previewNumber) {
      pcolorInput.addEventListener('change', function () {
        var hex = COLOR_MAP[pcolorInput.value] || '#ffffff';
        previewName.style.color = hex;
        previewNumber.style.color = hex;
      });
    }

    /* ================= Source toggle: catalog vs own upload ================= */
    var sourceButtons = root.querySelectorAll('[data-cjd-source-btn]');
    var sourcePanels  = root.querySelectorAll('[data-cjd-source-panel]');
    sourceButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-cjd-source-btn');
        sourceButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        sourcePanels.forEach(function (p) {
          if (p.getAttribute('data-cjd-source-panel') === target) show(p); else hide(p);
        });
        if (target === 'own') {
          if (selectedInput) selectedInput.value = '';
          hide(selectedChip);
          show(searchHint);
          setPreviewImage('');
          renderAngleSwitcher([]);
        } else {
          root.querySelectorAll('[data-cjd-own-angle-input]').forEach(function (inp) { inp.value = ''; });
          ownAngleImages = {};
          root.querySelectorAll('[data-cjd-angle-thumb]').forEach(function (t) {
            t.classList.remove('has-image'); t.style.backgroundImage = '';
          });
          setPreviewImage('');
          renderAngleSwitcher([]);
        }
      });
    });

    /* ================= Own item — multi-angle photo upload ================= */
    var ownAngleImages = {};
    var ownAngleInputs = root.querySelectorAll('[data-cjd-own-angle-input]');
    ownAngleInputs.forEach(function (input) {
      var angleKey = input.getAttribute('data-cjd-own-angle-input');
      var slot  = input.closest('[data-cjd-angle-slot]');
      var thumb = slot ? slot.querySelector('[data-cjd-angle-thumb]') : null;
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        if (file.size > 10 * 1024 * 1024) {
          showError('That photo is larger than 10MB. Please choose a smaller file.');
          input.value = '';
          return;
        }
        clearError();
        var reader = new FileReader();
        reader.onload = function (e) {
          ownAngleImages[angleKey] = e.target.result;
          if (thumb) {
            thumb.style.backgroundImage = 'url(' + e.target.result + ')';
            thumb.classList.add('has-image');
          }
          var orderedImages = ['front', 'back', 'left', 'right'].map(function (k) {
            return ownAngleImages[k] || null;
          });
          renderAngleSwitcher(orderedImages);
          if (angleKey === 'front' || !previewImg || previewImg.hidden) {
            setPreviewImage(e.target.result);
          }
          if (angleKey === 'front' && selectedInput) {
            selectedInput.value = "Customer's own item (uploaded photos)";
            var searchCol = root.querySelector('.cjd-search-col');
            if (searchCol) searchCol.classList.remove('cjd-invalid');
          }
        };
        reader.readAsDataURL(file);
      });
    });

    /* ================= Preview logo file (Step 1 only) ================= */
    if (fileInput && previewLogo) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file || !/^image\//.test(file.type)) {
          hide(previewLogo);
          previewLogo.removeAttribute('src');
          return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          previewLogo.src = e.target.result;
          show(previewLogo);
        };
        reader.readAsDataURL(file);
      });
    }

    /* ================= Draggable overlays ================= */
    root.querySelectorAll('[data-cjd-drag]').forEach(function (el) {
      var key = el.getAttribute('data-cjd-drag');
      var posInput = root.querySelector('[data-cjd-pos-input="' + key + '"]');
      var dragging = false;
      el.style.touchAction = 'none';
      function move(clientX, clientY) {
        if (!previewStage) return;
        var rect = previewStage.getBoundingClientRect();
        var x = ((clientX - rect.left) / rect.width) * 100;
        var y = ((clientY - rect.top) / rect.height) * 100;
        x = Math.max(2, Math.min(98, x));
        y = Math.max(2, Math.min(98, y));
        el.style.left = x + '%';
        el.style.top  = y + '%';
        if (posInput) posInput.value = Math.round(x) + '%, ' + Math.round(y) + '%';
      }
      el.addEventListener('pointerdown', function (e) { dragging = true; el.classList.add('is-dragging'); e.preventDefault(); });
      document.addEventListener('pointermove', function (e) { if (!dragging) return; move(e.clientX, e.clientY); });
      document.addEventListener('pointerup', function () { if (dragging) { dragging = false; el.classList.remove('is-dragging'); } });
      el.addEventListener('touchstart', function (e) { dragging = true; el.classList.add('is-dragging'); e.preventDefault(); }, { passive: false });
      document.addEventListener('touchmove', function (e) { if (!dragging || !e.touches[0]) return; move(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      document.addEventListener('touchend', function () { if (dragging) { dragging = false; el.classList.remove('is-dragging'); } });
    });

    var MAX_FILE_MB = 10;

    /* ---- Bulk order toggle + roster upload ---- */
    var bulkToggle      = root.querySelector('[data-cjd-bulk-toggle]');
    var bulkPanel       = root.querySelector('[data-cjd-bulk-panel]');
    var rosterInput     = root.querySelector('[data-cjd-roster-input]');
    var rosterFileNameEl= root.querySelector('[data-cjd-roster-filename]');
    var rosterChooseBtn = root.querySelector('[data-cjd-roster-choose]');
    var rosterUploadWrap= root.querySelector('[data-cjd-roster-upload]');

    if (bulkToggle && bulkPanel) {
      bulkToggle.addEventListener('change', function () {
        if (bulkToggle.checked) show(bulkPanel); else hide(bulkPanel);
      });
    }
    if (rosterChooseBtn && rosterInput) {
      rosterChooseBtn.addEventListener('click', function () { rosterInput.click(); });
    }
    if (rosterUploadWrap && rosterInput) {
      rosterUploadWrap.addEventListener('click', function (e) {
        if (e.target.tagName !== 'BUTTON') rosterInput.click();
      });
      ['dragenter','dragover'].forEach(function (evt) {
        rosterUploadWrap.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation();
          rosterUploadWrap.classList.add('is-dragover');
        });
      });
      ['dragleave','drop'].forEach(function (evt) {
        rosterUploadWrap.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation();
          rosterUploadWrap.classList.remove('is-dragover');
        });
      });
      rosterUploadWrap.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          rosterInput.files = dt.files;
          handleRosterFileChange();
        }
      });
    }
    if (rosterInput) rosterInput.addEventListener('change', handleRosterFileChange);
    function handleRosterFileChange() {
      var file = rosterInput.files && rosterInput.files[0];
      if (!file) { hide(rosterFileNameEl); return; }
      if (file.size > MAX_FILE_MB * 1024 * 1024) {
        showError('That file is larger than ' + MAX_FILE_MB + 'MB. Please choose a smaller file.');
        rosterInput.value = '';
        hide(rosterFileNameEl);
        return;
      }
      clearError();
      if (rosterFileNameEl) { rosterFileNameEl.textContent = file.name; show(rosterFileNameEl); }
    }

    /* ---- Preview logo drag & drop (Step 1 only) ---- */
    if (chooseBtn && fileInput) {
      chooseBtn.addEventListener('click', function () { fileInput.click(); });
    }
    if (uploadWrap && fileInput) {
      uploadWrap.addEventListener('click', function (e) {
        if (e.target.tagName !== 'BUTTON') fileInput.click();
      });
      ['dragenter','dragover'].forEach(function (evt) {
        uploadWrap.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation();
          uploadWrap.classList.add('is-dragover');
        });
      });
      ['dragleave','drop'].forEach(function (evt) {
        uploadWrap.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation();
          uploadWrap.classList.remove('is-dragover');
        });
      });
      uploadWrap.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          fileInput.files = dt.files;
          handleFileChange();
        }
      });
    }
    if (fileInput) fileInput.addEventListener('change', handleFileChange);
    function handleFileChange() {
      var file = fileInput && fileInput.files && fileInput.files[0];
      if (!file) { if (fileNameEl) hide(fileNameEl); return; }
      if (file.size > MAX_FILE_MB * 1024 * 1024) {
        showError('That file is larger than ' + MAX_FILE_MB + 'MB. Please choose a smaller file.');
        fileInput.value = '';
        if (fileNameEl) hide(fileNameEl);
        return;
      }
      clearError();
      if (fileNameEl) { fileNameEl.textContent = file.name; show(fileNameEl); }
    }

    /* ---- Show filename for contact info logo uploads ---- */
    ['club-logo', 'sponsor-logo', 'other-logo'].forEach(function(key) {
      var input = root.querySelector('#cjd-' + key + '-' + sectionId);
      if (!input) return;
      input.addEventListener('change', function() {
        var file = this.files && this.files[0];
        var nameEl = root.querySelector('#cjd-' + key + '-name-' + sectionId);
        if (nameEl) nameEl.textContent = file ? file.name : '';
      });
    });

    /* ---- Character counter ---- */
    if (notesEl && countEl) {
      notesEl.addEventListener('input', function () { countEl.textContent = notesEl.value.length; });
    }

    /* ---- Live total ---- */
    function recalcTotal() {
      if (!totalEl) return;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var sum = 0;
      addonInputs.forEach(function (cb) {
        if (cb.checked) sum += parseFloat(cb.getAttribute('data-price')) || 0;
      });
      totalEl.textContent = '$' + (sum * qty).toFixed(2);
    }
    addonInputs.forEach(function (cb) {
      cb.addEventListener('change', function () {
        recalcTotal();
        var addonsWrap  = root.querySelector('.cjd-addons');
        var addonsField = addonsWrap ? addonsWrap.closest('.cjd-field') : null;
        var anyChecked  = false;
        addonInputs.forEach(function (c) { if (c.checked) anyChecked = true; });
        if (addonsField && anyChecked) addonsField.classList.remove('cjd-invalid');
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', recalcTotal);
    recalcTotal();

    /* ---- Validation ---- */
    function validate() {
      var valid = true;
      form.querySelectorAll('[required]').forEach(function (field) {
        var wrap   = field.closest('.cjd-field');
        var filled = field.value && field.value.trim().length > 0;
        if (!filled) {
          valid = false;
          if (wrap) wrap.classList.add('cjd-invalid');
        } else if (wrap) {
          wrap.classList.remove('cjd-invalid');
        }
      });
      if (addonInputs.length > 0) {
        var anyChecked  = false;
        addonInputs.forEach(function (cb) { if (cb.checked) anyChecked = true; });
        var addonsWrap  = root.querySelector('.cjd-addons');
        var addonsField = addonsWrap ? addonsWrap.closest('.cjd-field') : null;
        if (!anyChecked) {
          valid = false;
          if (addonsField) addonsField.classList.add('cjd-invalid');
        } else if (addonsField) {
          addonsField.classList.remove('cjd-invalid');
        }
      }
      return valid;
    }
    form.querySelectorAll('[required]').forEach(function (field) {
      field.addEventListener('input', function () {
        var wrap = field.closest('.cjd-field');
        if (wrap && field.value.trim()) wrap.classList.remove('cjd-invalid');
      });
      field.addEventListener('change', function () {
        var wrap = field.closest('.cjd-field');
        if (wrap && field.value.trim()) wrap.classList.remove('cjd-invalid');
      });
    });

    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; show(errorEl); }
    function clearError()   { if (!errorEl) return; hide(errorEl); errorEl.textContent = ''; }

    /* ---- Submit ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var hp = form.querySelector('.cjd-hp');
      if (hp && hp.value) return;

      /* selectedInput is optional (preview panel may be collapsed/skipped) */
      if (selectedInput && selectedInput.required && !selectedInput.value) {
        showError('Please select a product or upload a front photo of your item before submitting.');
        var searchCol = root.querySelector('.cjd-search-col');
        if (searchCol) searchCol.classList.add('cjd-invalid');
        if (searchInput) searchInput.focus();
        return;
      }

      if (!validate()) {
        showError('Please fill in all required fields marked with *.');
        var firstInvalid = form.querySelector('.cjd-invalid input, .cjd-invalid select, .cjd-invalid textarea');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Submitting…';

      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;

      /* Read Print Name/Number from Step 3 (order fields) for the refTag */
      var pnameOrder = form.querySelector('[name="properties[Print Name]"]');
      var pnumOrder  = form.querySelector('[name="properties[Print Number]"]');
      var refTag = 'For: ' + (pnameOrder ? pnameOrder.value : '') +
                   (pnumOrder && pnumOrder.value ? ' #' + pnumOrder.value : '');

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data && data.description ? data.description : 'Something went wrong.');
            });
          }
          return res.json();
        })
        .then(function () {
          var items = [];
          addonInputs.forEach(function (cb) {
            if (cb.checked) {
              items.push({
                id: parseInt(cb.getAttribute('data-variant-id'), 10),
                quantity: qty,
                properties: { 'Add-on for': refTag }
              });
            }
          });
          if (items.length === 0) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add one of the selected print options.');
              });
            }
            return res.json();
          });
        })
        .then(function () { window.location.href = redirectUrl; })
        .catch(function (err) {
          submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = 'Submit Request';
          showError(err.message || 'Something went wrong. Please try again.');
        });
    });
  }

  return { init: init };
})();
